import { labSessionAdapter } from "./lab-session";
import { virtualInvestmentAdapter } from "./virtual-investment";

export { pageSplitToCssWidth } from "./page-split";
export { labCompositionToReviewTickers, scenarioIdFromColumns } from "./virtual-investment";

/** Single entry point for all Portfolio Lab adapters. Each sub-adapter implements the adapter contract. */
export const portfolioLabAdapter = {
	labSession: labSessionAdapter,
	virtualInvestment: virtualInvestmentAdapter,
};
